import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

/**
 * Auth Selectors
 *
 * For selecting auth-related state (loading, errors).
 * For user data, use user.selectors.ts instead.
 */

// Select the auth feature state
export const selectAuthState = createFeatureSelector<AuthState>('auth');

// Select loading state
export const selectAuthLoading = createSelector(
	selectAuthState,
	(state) => state.loading
);

// Select error state
export const selectAuthError = createSelector(
	selectAuthState,
	(state) => state.error
);

// Select return URL
export const selectReturnUrl = createSelector(
	selectAuthState,
	(state) => state.returnUrl
);
